import React, { useState, useEffect, useRef } from 'react';
import HubspotForm from "react-hubspot-form";
import { Link } from './Link';
import Modal from './Modal';
 
export const RestaurantSignUp = ({ noModal }) => {
  const [showModal, setShowModal] = useState(false);
  const firstInput = useRef(null);
 
  const openModal = event => {
    event.preventDefault();
    setShowModal(true);
  };
 
  const closeModal = event => {
    event.preventDefault();
    setShowModal(false);
  };
 
  useEffect(() => {
    if (firstInput && firstInput.current) firstInput.current.focus();
  }, [showModal]);
 
  if (noModal) {
    return (
      <Link to="/restaurant-sign-up" className="button primary">
        Request a 10-minute demo
      </Link>
    );
  }
 
  return (
    <>
      <a href="#open" onClick={openModal} className="button primary">
        Request a 10-minute demo
      </a>
      <Modal
        active={showModal}
        title="Request a 10 minute demo"
        closeModal={closeModal}
      >
        <HubspotForm
          portalId="3915094"
          formId="620daf17-f8c0-4274-8469-ed4f6b9b2369"
          onSubmit={() => console.log("Submit!")}
          onReady={(form) => console.log("Form ready!")}
          loading={<div>Loading...</div>}
        />
      </Modal>
    </>
  );
};
